import React from "react";
import { Link } from "react-router-dom";

function OutletCard({data, handleDelete}) {
  return (
    <div
      className="border rounded-lg p-4 font-semibold h-auto bg-white shadow-xl text-center"
    >
      <div className="flex justify-center py-3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          className="fill-[#7B20C7]"
          width="80"
          height="50"
        >
          <path d="M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1c1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304V160zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2c-.1-.7-.3-1.4-.5-2.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l12.8 64.2c9.6 1 19 4.9 26.6 11.8c11.7 10.6 23 21.6 33.9 33.1c1.7-1.6 3.3-3.2 5-4.8zM325.2 210.7c3.8-6.2 7.9-12.5 12.3-18.7H32l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H337.6c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4zM480 480c88.4 0 160-71.6 160-160c0-31.8-15.5-84-74.4-142.4c-11.8-11.7-30.6-10.7-42.3 1L512 189.9l-46-46c-6-6.1-14.1-9.3-22-9.2c-5.9 .1-11.8 1.9-16.8 5.8C382.5 175.3 320 243.3 320 320c0 88.4 71.6 160 160 160zm64-111.8c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 295.1 544 331.6 544 368.2z" />
        </svg>
      </div>
      <h1 className="text-2xl text-black ">{data.name}</h1>
      <span className="text-[#6f6b7d] text-md">{data.code}</span>
      <p className="text-lg py-2">{data.address}</p>
      <p>{data.phone}</p>
      <p>{data.email}</p>
      <div>
        <ul className="flex justify-center gap-1">
          {/* <li>
            <Link
              className="bg-[#7B20C7] text-white  text-md px-6 mt-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 text-center w-fit"
              type="button"
            >
              Enter
            </Link>
          </li> */}
          <li>
            <Link
              to={`addOutlet/${data.id}`}
              className="bg-[#7B20C7] text-white  text-md px-6 mt-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 text-center w-fit"
              type="button"
            >
              Edit
            </Link>
          </li>
          <li>
            <button
              onClick={() => handleDelete(data.id)}
              className="bg-[#7B20C7] text-white  text-md px-6 mt-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 text-center w-fit"
              type="button"
            >
              Delete
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default OutletCard;
